import { todayFeed } from '@/mocks/blackinfo';

const statusTone: Record<string, string> = {
  新爆出: 'text-red-700 bg-red-50 border-red-200',
  核实中: 'text-amber-700 bg-amber-50 border-amber-200',
  当事人回应: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  各方说法: 'text-stone-700 bg-stone-100 border-stone-200',
  联盟介入: 'text-stone-700 bg-stone-100 border-stone-200',
  持续关注: 'text-stone-700 bg-stone-100 border-stone-200',
  完整复盘: 'text-stone-700 bg-stone-100 border-stone-200',
  关联起底: 'text-stone-700 bg-stone-100 border-stone-200',
};

export default function TodayFeed() {
  return (
    <section id="today" className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6 md:pt-16">
      <div className="flex items-end justify-between border-b border-stone-200 pb-3">
        <div>
          <h2 className="font-display text-xl font-bold text-stone-950 md:text-2xl">
            今日新料
            <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-xs font-bold text-red-600 align-middle">
              <i className="ri-flashlight-fill" /> 持续刷新
            </span>
          </h2>
          <p className="mt-1 text-xs text-stone-500 md:text-sm">按出现时间倒序，附事件当前状态，方便你判断每条新料的可信程度。</p>
        </div>
        <a
          href="#report"
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-red-600 hover:text-red-700 sm:inline-flex"
        >
          补充线索 <i className="ri-add-line" />
        </a>
      </div>

      <div className="mt-2 divide-y divide-stone-100">
        {todayFeed.map((s) => (
          <a
            key={s.id}
            href="#timeline"
            className="group flex flex-col gap-3 py-4 sm:flex-row sm:items-start sm:gap-6 sm:py-5"
          >
            {/* 时间 */}
            <div className="shrink-0 sm:w-16 sm:pt-1">
              <span className="text-sm font-semibold text-stone-900 sm:block">{s.time.slice(3)}</span>
              <span className="hidden text-[11px] text-stone-400 sm:block">今日</span>
            </div>
            {/* 正文 */}
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-stone-100 px-2 py-0.5 text-xs font-medium text-stone-600">{s.tag}</span>
                <span
                  className={
                    'rounded-full border px-2 py-0.5 text-[11px] font-medium ' + (statusTone[s.status] || '')
                  }
                >
                  {s.status}
                </span>
              </div>
              <h3 className="mt-1.5 font-display text-base font-bold leading-snug text-stone-900 group-hover:text-red-700 md:text-lg">
                {s.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-stone-500 md:text-sm">{s.summary}</p>
            </div>
            {/* 热度 */}
            <div className="flex shrink-0 items-center gap-4 sm:flex-col sm:items-end sm:gap-1 sm:pt-1">
              <span className="inline-flex items-center gap-1 text-xs font-medium text-red-500">
                <i className="ri-fire-fill" /> {s.heat}
              </span>
              <span className="hidden text-[11px] text-stone-400 sm:inline">{s.read}</span>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-2 flex items-center justify-center pt-2">
        <a
          href="#explosive"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-stone-600 hover:text-stone-950"
        >
          往下翻，看今天的硬核猛料 <i className="ri-arrow-down-line" />
        </a>
      </div>
    </section>
  );
}